<div>
  <app-trend-by-country-filters *ngIf="years"
    [years]="years"
    [categories]="categories"
    [countryCategory]="countryCategory"
    (loadCategories)="loadCategories($event)"
    (search)="searchData($event)"
  ></app-trend-by-country-filters>
  <mat-divider></mat-divider>
  <div class="chart-container" *ngIf="data">
    <app-trend-by-country-bar-chart
      [title]="text"
      [subtitle]="subtitle"
      [countryCategory]="countryCategory"
      [displayUnits]="displayUnits"
      [countries]="countries"
      [data]="data">
    </app-trend-by-country-bar-chart>
  </div>
</div>
